import React from 'react'
import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>Guruh ma'lumotlari</title>
		</Helmet>
	)
}

export default Head
